import { AccountCircle, ArrowBack } from "@mui/icons-material";
import { Grid, IconButton, styled } from "@mui/material";
import { AppBar, Toolbar } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import ConfirmationDialog from "../common/ConfirmationDialog";
import { useExerciseSession } from "../ExerciseSessionProvider";
import Logo from "../images/logo.svg";
import { useLogging } from "../logging/useLogging";
import { pages } from "../pages/pages";
import { AppEvent } from "../types";

const MasterHeader: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [navigateToAfterCancel, setNavigateToAfterCancel] = React.useState("");

    const { clearSession } = useExerciseSession();
    const { log } = useLogging();

    const isSessionActive = useMemo(
        () => location.pathname.includes("/exercise") || location.pathname.includes("/ai-exercise-session"),
        [location.pathname],
    );

    // TODO: Uncomment when AI works for de and en
    // const handleLanguageChange = () => {
    //     i18n.changeLanguage(i18n.language === "en" ? "de" : "en");
    // };

    const handleCancelSession = (cancel?: boolean) => {
        if (cancel) {
            clearSession();
            log(AppEvent.SessionCancelled);
            navigate(navigateToAfterCancel);
        }

        setDialogOpen(false);
    };

    const handleNavigation = () => {
        if (
            location.pathname.includes("/exercises/") ||
            location.pathname === pages.session ||
            location.pathname === pages.imprint ||
            location.pathname === pages.setting
        ) {
            navigate(-1);
        } else {
            navigate(pages.home);
        }
    };

    return (
        <AppBar position="fixed" color="inherit">
            <Toolbar disableGutters={true} sx={{ height: 56, minHeight: { sm: 56 } }}>
                <Grid container alignItems="center">
                    <Grid item xs={3}>
                        {location.pathname !== pages.home && (
                            <IconButton
                                size="large"
                                color="inherit"
                                onClick={() => {
                                    if (isSessionActive) {
                                        setDialogOpen(true);
                                        setNavigateToAfterCancel(pages.home);
                                    } else {
                                        handleNavigation();
                                    }
                                }}
                            >
                                <ArrowBack />
                            </IconButton>
                        )}
                    </Grid>
                    <Grid item xs={6}>
                        <ImageContainer>
                            <img
                                src={Logo}
                                onClick={() => {
                                    if (isSessionActive) {
                                        setDialogOpen(true);
                                        setNavigateToAfterCancel(pages.home);
                                    } else {
                                        navigate(pages.home);
                                    }
                                }}
                                style={{ height: 40 }}
                            />
                        </ImageContainer>
                    </Grid>
                    <Grid item xs={3}>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            {/* TODO: Uncomment when AI works for de and en*/}
                            {/* <LanguageContainer>
                                <Typography style={{ marginRight: 10 }} onClick={handleLanguageChange}>
                                    {i18n.language === "en" ? "DE" : "EN"}
                                </Typography>
                            </LanguageContainer>
                            <Divider
                                orientation="vertical"
                                variant="middle"
                                flexItem
                                style={{ borderColor: "white", marginTop: 15, marginBottom: 15 }}
                            /> */}
                            <IconButton
                                size="large"
                                onClick={() => {
                                    if (isSessionActive) {
                                        setDialogOpen(true);
                                        setNavigateToAfterCancel(pages.profile);
                                    } else {
                                        navigate(pages.profile);
                                    }
                                }}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                        </div>
                    </Grid>
                </Grid>
            </Toolbar>
            <ConfirmationDialog open={dialogOpen} onClose={handleCancelSession} title="cancel_session">
                {t("cancel_session_content")}
            </ConfirmationDialog>
        </AppBar>
    );
};

export default MasterHeader;

const ImageContainer = styled("div")`
    flex-grow: 1;
    justify-content: center;
    display: flex;
    padding: 5px:
`;

// TODO: Uncomment when AI works for de and en
// const LanguageContainer = styled("div")`
//     margin: 20px 0;
// `;
